module.exports = __webpack_public_path__ + "static/img/icon_category_search.641ce52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_category_search.svg
// module id = hZdF
// module chunks = 10